<template>
    <div class="ticket h-100 bg-light rounded-left">
        <div class="ticket-row row h-100 align-items-center">
            <div
                :class="
                    canBeBought ? 'col-12 col-md' : 'col-12 col-md text-muted'
                "
            >
                <div class="title pl-md-3">
                    <hr class="m-0 p-0 d-md-none w-50 mx-auto mb-3" />
                    {{ ticket.name }}
                    {{ isLastMinuteDiscount ? ' - Last Minute' : '' }}
                </div>
            </div>
            <div
                v-if="ticket.available_tickets_number != null"
                class="col-2 text-center"
            >
                <span
                    :class="
                        canBeBought
                            ? 'available-tickets'
                            : 'available-tickets text-muted'
                    "
                >
                    {{ event.ticketTypesQuantity[ticket.id] }}&nbsp;/&nbsp;{{
                        ticket.available_tickets_number
                    }}
                </span>
            </div>
            <div class="col-12 col-md-3 text-center py-3 py-md-0">
                <template v-if="ticket.is_free == 0">
                    <template v-if="isLastMinuteDiscount">
                        <span
                            :class="
                                canBeBought
                                    ? 'price text-success'
                                    : 'price text-muted'
                            "
                        >
                            {{ cost(ticket) }}
                        </span>
                    </template>
                    <template v-else>
                        <span
                            :class="canBeBought ? 'price' : 'price text-muted'"
                        >
                            {{ cost(ticket) }}
                        </span>
                    </template>
                </template>
                <template v-else>
                    <span :class="canBeBought ? 'price' : 'price text-muted'">
                        {{ app.locale.trans('user.cart.product.free') }}
                    </span>
                </template>
            </div>
            <div
                class="col-12 d-flex h-100"
                :class="$parent.isAdmin ? 'col-md-4' : 'col-md-3'"
            >
                <button
                    v-if="canBeBought"
                    class="add-to-cart btn btn-success text-white h-100 w-100 rounded-right"
                    :title="app.locale.trans('user.cart.add_to_cart')"
                    @click="addTicketToCart()"
                >
                    <i class="fas fa-shopping-cart"></i>
                </button>
                <button
                    v-else
                    class="add-to-cart btn btn-success text-white h-100 w-100 rounded-right"
                    :title="app.locale.trans('user.cart.no_ticket_left')"
                    disabled="disabled"
                >
                    <i class="fas fa-shopping-cart d-none d-md-inline"></i>
                    <span class="d-block d-md-none">{{
                        app.locale.trans('user.cart.no_ticket_left')
                    }}</span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        ticket: Object,
        event: Object,
        isCourseFull: Boolean,
        economicViability: Number,
        isBookable: Boolean,
    },

    data() {
        let isLastMinuteDiscount =
            this.event.boughtTicketsCount >= this.economicViability &&
            this.dateIsInLessThan1Week(this.event.start_datetime);

        let discountedPrice = null;

        if (isLastMinuteDiscount) {
            discountedPrice = Math.round(this.ticket.cost * 0.8);
        }

        return {
            cart_url: appData.page.vars.cart_url,
            discountedPrice: discountedPrice,
            isLastMinuteDiscount: isLastMinuteDiscount,
        };
    },

    methods: {
        cost(ticket) {
            if (this.isLastMinuteDiscount) {
                return window.app.formatPrice(
                    this.discountedPrice,
                    ticket.currency.code
                );
            } else {
                return window.app.formatPrice(
                    ticket.cost,
                    ticket.currency.code
                );
            }
        },

        addTicketToCart: function () {
            let price = this.discountedPrice ?? this.ticket.cost;

            this.$parent.cartApiService
                .addCartCourse(
                    this.ticket.id,
                    this.ticket.name,
                    price,
                    1,
                    this.ticket.currency.id,
                    this.event,
                    appData.page.vars.city_id
                )
                .then((gtmData) => {
                    // Send only current cart item.
                    gtmData.ecommerce.items =
                        appData.page.vars.gtmData.ecommerce.items;
                    gtmData.ecommerce.value =
                        appData.page.vars.gtmData.ecommerce.value;

                    // Trigger GTM event.
                    this.app.gtm.trigger('add_to_cart', {
                        // Get data from response.
                        ...gtmData,
                        ...{
                            ticket: this.ticket,
                        },
                    });

                    // Redirect.
                    window.location = this.cart_url;
                })
                .catch((error) => {
                    this.$parent.$refs.alertBox.handleError(error);
                });
        },

        dateIsInLessThan1Week(dateTime) {
            let now = new Date();
            let inOneWeek = now.setDate(now.getDate() + 7);
            inOneWeek = new Date(inOneWeek);

            let eventDate = new Date(dateTime);

            return inOneWeek > eventDate;
        },
    },

    computed: {
        canBeBought() {
            return this.isBookable;
        }
    },
};
</script>
